import React from 'react';
import { withModules } from '@/Hocs';

const ProfileSubscriptionsPageComponent = (): React.ReactElement => {
  return <section />;
};

export const ProfileSubscriptionsPage = withModules(ProfileSubscriptionsPageComponent);
